import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/styles';
import {
  Box,
  Button,
  Grid,
  FormGroup,
  TextField,
  FormControl,
  FormControlLabel,
  Input,
  InputLabel,
  MenuItem,
  Select,
  Chip,
  Checkbox,
} from '@material-ui/core';
import DatePicker from 'react-datepicker';
import styles from 'styles/admin-search.module.scss';
import 'react-datepicker/dist/react-datepicker.css';
import 'styles/css/datepicker-override.css';
import {
  RESPONSE_STATUS_VALUES,
  CAR_TAB_RESPONSE_STATUSES,
  FIRE_AND_INJURY_TAB_RESPONSE_STATUSES,
  CHANGE_TYPE_VALUES,
  CAR_TAB_CHANGE_TYPES,
  FIRE_AND_INJURY_TAB_CHANGE_TYPES,
} from 'const';
import { ButtonGroup } from './ButtonGroup'
import { StatusSelectGroup } from './StatusSelectGroup'

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: '#FFF',
    padding: 15,
    paddingTop: 0,
  },
  row: {
    alignItems: 'center',
    marginTop: theme.spacing(1),
  },
  formGroup: {
    width: '100%',
    margin: 0,
    padding: 0,
  },
  multiSelector: {
    marginBottom: 10,
  },
  chips: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  searchItemTitle: {
    fontSize: 14,
    marginBottom: 8,
    color: '#3d3d3d',
  },
  other: {
    marginTop: 15,
    marginLeft: 10,
    color: '#757575',
  },
  searchItem: {
    color: '#757575',
  },
  searchButton: {
    marginTop: 20,
    marginRight: 10,
    float: 'right',
    width: 100,
  },
  multiSelect: {
    width: 'calc(100% - 180px)',
  },
}));

const SearchToolbar = (props) => {
  const {
    className,
    policyNumber,
    setPolicyNumber,
    name,
    setName,
    nameKana,
    setNameKana,
    applyIdRef,
    createdAtFrom,
    setCreatedAtFrom,
    createdAtTo,
    setCreatedAtTo,
    responseStatuses,
    setResponseStatuses,
    necessaryChangeTypes,
    setNecessaryChangeTypes,
    allowedChangeTypes,
    setAllowedChangeTypes,
    isIdentifiedAll,
    setIsIdentifiedAll,
    feeCategory,
    setFeeCategory,
    cancellationCategory,
    setCancellationCategory,
    existsCallDesignated,
    setExistsCallDesignated,
    isSmsSendingRequired,
    setIsSmsSendingRequired,
    lineChatAvailability,
    setLineChatAvailability,
    onClickSearch,
    searchTabType,
    ...rest
  } = props;

  const handleIsCallDesignation = () => {
    setExistsCallDesignated(!existsCallDesignated);
  };

  const handleIsSmsSendingRequired = () => {
    setIsSmsSendingRequired(!isSmsSendingRequired);
  };

  const classes = useStyles();

  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
      },
    },
  };

  const [changeTypeOptionList, setChangeTypeOptionList] = useState([]);
  const [responseStatusOptionList, setResponseStatusOptionList] = useState([]);
  useEffect(() => {
    if (searchTabType === 'car') {
      setChangeTypeOptionList(CAR_TAB_CHANGE_TYPES);
      setResponseStatusOptionList(CAR_TAB_RESPONSE_STATUSES);
    } else if (searchTabType === 'fireAndInjury') {
      setChangeTypeOptionList(FIRE_AND_INJURY_TAB_CHANGE_TYPES);
      setResponseStatusOptionList(FIRE_AND_INJURY_TAB_RESPONSE_STATUSES);
    }
  }, [searchTabType]);


  return (
    <div {...rest} className={clsx(classes.root, className)}>
      <div className={classes.row}>
        <Grid item className={styles.root}>
          <Grid container spacing={2} className={styles.paddingTopZero}>
            <Grid item xs={6}>
              <FormGroup className={classes.formGroup}>
                <label className={styles.searchItemTitleChanges}>変更内容</label>
                <Box border={1} className={styles.searchItemBoxChanges}>
                  <FormControl className={classes.multiSelector}>
                    <InputLabel className={classes.searchItem}>
                      いずれかを必ず含む
                    </InputLabel>
                    <Select
                      className={classes.multiSelect}
                      multiple
                      value={necessaryChangeTypes}
                      onChange={(event) => setNecessaryChangeTypes(event.target.value)}
                      input={<Input />}
                      renderValue={(selected) => (
                        <div className={classes.chips}>
                          {selected.map((value) => (
                            <Chip
                              key={value}
                              label={CHANGE_TYPE_VALUES[value]}
                              className={classes.chip}
                            />
                          ))}
                        </div>
                      )}
                      MenuProps={MenuProps}
                    >
                      {changeTypeOptionList.map((value) => (
                        <MenuItem key={value} value={value}>
                          {CHANGE_TYPE_VALUES[value]}
                        </MenuItem>
                      ))}
                    </Select>
                    <ButtonGroup state={changeTypeOptionList} action={setNecessaryChangeTypes} />
                  </FormControl>
                  <FormControl className={classes.multiSelector}>
                    <InputLabel className={classes.searchItem}>
                      含んでいても良い
                    </InputLabel>
                    <Select
                      className={classes.multiSelect}
                      multiple
                      value={allowedChangeTypes}
                      onChange={(event) => setAllowedChangeTypes(event.target.value)}
                      input={<Input />}
                      renderValue={(selected) => (
                        <div className={classes.chips}>
                          {selected.map((value) => (
                            <Chip
                              key={value}
                              label={CHANGE_TYPE_VALUES[value]}
                              className={classes.chip}
                            />
                          ))}
                        </div>
                      )}
                      MenuProps={MenuProps}
                    >
                      {changeTypeOptionList.map((value) => (
                        <MenuItem key={value} value={value}>
                          {CHANGE_TYPE_VALUES[value]}
                        </MenuItem>
                      ))}
                    </Select>
                    <ButtonGroup state={changeTypeOptionList} action={setAllowedChangeTypes} />
                  </FormControl>
                </Box>
              </FormGroup>
            </Grid>
            <Grid item xs={6}>
              <FormGroup className={classes.formGroup}>
                <label className={styles.searchItemTitleStatus}>ステータス</label>
                <Box border={1} className={styles.searchItemBoxStatus}>
                  <FormControl className={classes.multiSelector}>
                    <Select
                      className={classes.multiSelect}
                      multiple
                      value={responseStatuses}
                      onChange={(event) => setResponseStatuses(event.target.value)}
                      input={<Input />}
                      renderValue={(selected) => (
                        <div className={classes.chips}>
                          {selected.map((value) => (
                            <Chip
                              key={value}
                              label={RESPONSE_STATUS_VALUES[value]}
                              className={classes.chip}
                            />
                          ))}
                        </div>
                      )}
                      MenuProps={MenuProps}
                    >
                      {responseStatusOptionList.map((value) => (
                        <MenuItem key={value} value={value}>
                          {RESPONSE_STATUS_VALUES[value]}
                        </MenuItem>
                      ))}
                    </Select>
                    <ButtonGroup state={responseStatusOptionList} action={setResponseStatuses} />
                  </FormControl>

                  <FormGroup row style={{'marginTop': '15px', 'marginLeft': '10px'}}>
                    <StatusSelectGroup
                      identification={{
                        state: isIdentifiedAll,
                        action: setIsIdentifiedAll,
                      }}
                      fee={{
                        state: feeCategory,
                        action: setFeeCategory,
                      }}
                      cancellation={{
                        state: cancellationCategory,
                        action: setCancellationCategory,
                      }}
                      line={{
                        state: lineChatAvailability,
                        action: setLineChatAvailability,
                      }}
                    />
                  </FormGroup>

                  <FormGroup row style={{'marginLeft': '26px'}}>
                    <FormControlLabel
                      className={classes.searchItem}
                      control={
                        <Checkbox
                          checked={isSmsSendingRequired}
                          onChange={handleIsSmsSendingRequired}
                          color='primary'
                        />
                      }
                      label='SMS'
                    />
                    <FormControlLabel
                      className={classes.searchItem}
                      control={
                        <Checkbox
                          checked={existsCallDesignated}
                          onChange={handleIsCallDesignation}
                          color='primary'
                        />
                      }
                      label='コール指定あり'
                    />
                  </FormGroup>
                </Box>
              </FormGroup>
            </Grid>
            <Grid item xs={6}>
              <FormGroup row className={classes.formGroup}>
                <FormControl fullWidth={true}>
                  <label className={styles.searchItemTitleReceptionPeriod}>受付期間</label>
                  <Box border={1} className={styles.searchItemBoxReceptionPeriod}>
                    <FormControl>
                      <DatePicker
                        className={styles.datePicker}
                        selected={createdAtFrom}
                        maxDate={new Date('2999/12/31')}
                        minDate={new Date('2000/01/01')}
                        onChange={(date) => setCreatedAtFrom(date)}
                        dateFormat='yyyy/MM/dd HH:mm'
                        placeholderText='年/月/日 時:分'
                        isClearable
                        timeCaption='時刻'
                        timeFormat='HH:mm'
                        showTimeSelect
                      />
                    </FormControl>
                    <p className={styles.datePickerHyphen}>~</p>
                    <FormControl>
                      <DatePicker
                        className={styles.datePicker}
                        selected={createdAtTo}
                        maxDate={new Date('2999/12/31')}
                        minDate={new Date('2000/01/01')}
                        onChange={(date) => setCreatedAtTo(date)}
                        dateFormat='yyyy/MM/dd HH:mm'
                        placeholderText='年/月/日 時:分'
                        isClearable
                        timeCaption='時刻'
                        timeFormat='HH:mm'
                        showTimeSelect
                      />
                    </FormControl>
                  </Box>
                </FormControl>
              </FormGroup>
            </Grid>
            <Grid item xs={6}>
              <FormGroup row className={classes.formGroup}>
                <FormControl fullWidth={true}>
                  <label className={styles.searchItemTitleItem}>項目条件</label>
                  <Box border={1} className={styles.searchItemBoxItems}>
                    <FormControl>
                      <label className={classes.searchItemTitle}>連番</label>
                      <TextField
                        InputLabelProps={{
                          shrink: true,
                          style: {
                            color: 'rgba(0, 0, 0, 0.54)',
                            fontSize: '16px',
                          },
                        }}
                        type={'text'}
                        size='small'
                        variant='outlined'
                        inputRef={applyIdRef}
                        defaultValue={''}
                      />
                    </FormControl>
                    <FormControl>
                      <label className={classes.searchItemTitle}>証券番号</label>
                      <TextField
                        InputLabelProps={{
                          shrink: true,
                          style: {
                            color: 'rgba(0, 0, 0, 0.54)',
                            fontSize: '16px',
                          },
                        }}
                        type={'text'}
                        size='small'
                        variant='outlined'
                        onChange={(e) => setPolicyNumber(e.target.value)}
                        value={policyNumber || ''}
                      />
                    </FormControl>
                    <FormControl>
                      <label className={classes.searchItemTitle}>契約者名（漢字）</label>
                      <TextField
                        InputLabelProps={{
                          shrink: true,
                          style: {
                            color: 'rgba(0, 0, 0, 0.54)',
                            fontSize: '16px',
                          },
                        }}
                        type={'text'}
                        size='small'
                        variant='outlined'
                        onChange={(e) => setName(e.target.value)}
                        value={name || ''}
                      />
                    </FormControl>
                    <FormControl>
                      <label className={classes.searchItemTitle}>契約者名（カナ）</label>
                      <TextField
                        InputLabelProps={{
                          shrink: true,
                          style: {
                            color: 'rgba(0, 0, 0, 0.54)',
                            fontSize: '16px',
                          },
                        }}
                        type={'text'}
                        size='small'
                        variant='outlined'
                        onChange={(e) => setNameKana(e.target.value)}
                        value={nameKana || ''}
                      />
                    </FormControl>
                  </Box>
                  <div>
                    <Button
                      className={classes.searchButton}
                      color='primary'
                      variant='contained'
                      onClick={() => {
                        onClickSearch();
                      }}
                    >
                      検索
                    </Button>
                  </div>
                </FormControl>
              </FormGroup>
            </Grid>
          </Grid>
        </Grid>
      </div>
    </div>
  );
};

SearchToolbar.propTypes = {
  className: PropTypes.string,
};

export default SearchToolbar;